import React from "react";
import { Vote } from "lucide-react";

export function Brand({ size = "md", invert = false }) {
  const cls = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
  }[size];
  const iconSize = { sm: 16, md: 18, lg: 22 }[size];
  return (
    <div
      className={`flex items-center gap-2 font-semibold ${cls} ${invert ? "text-white" : "text-slate-900"}`}
      data-testid="brand-logo"
    >
      <span
        className={`inline-flex items-center justify-center w-8 h-8 rounded-md ${invert ? "bg-white/10" : "bg-blue-700 text-white"}`}
      >
        <Vote size={iconSize} />
      </span>
      <span className="tracking-tight">
        Ward<span className="font-mono">Intel</span>
      </span>
    </div>
  );
}

export function StatTile({ label, value, hint, icon: Icon, accent }) {
  return (
    <div
      className="p-5 wi-card flex flex-col justify-between min-h-[112px]"
      data-testid={`stat-tile-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      <div className="flex items-start justify-between">
        <span className="data-label">{label}</span>
        {Icon && (
          <Icon size={18} className={accent || "text-slate-400"} strokeWidth={2} />
        )}
      </div>
      <div className="mt-3">
        <div className="metric-value text-3xl text-slate-900">{value}</div>
        {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
      </div>
    </div>
  );
}

export function SectionHeader({ eyebrow, title, action }) {
  return (
    <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
      <div>
        {eyebrow && <div className="data-label mb-1">{eyebrow}</div>}
        <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-slate-900">
          {title}
        </h2>
      </div>
      {action}
    </div>
  );
}

export function Pill({ tone = "neutral", children, ...rest }) {
  const tones = {
    neutral: "bg-slate-100 text-slate-700",
    blue: "bg-blue-50 text-blue-700 border border-blue-100",
    green: "bg-emerald-50 text-emerald-700 border border-emerald-100",
    red: "bg-red-50 text-red-700 border border-red-100",
    yellow: "bg-amber-50 text-amber-700 border border-amber-100",
  };
  return (
    <span
      className={`inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full ${tones[tone]}`}
      {...rest}
    >
      {children}
    </span>
  );
}

export function EmptyState({ title, hint }) {
  return (
    <div className="border border-dashed border-slate-200 rounded-lg p-10 text-center bg-slate-50">
      <div className="data-label mb-2">No data</div>
      <div className="text-slate-700 font-medium">{title}</div>
      {hint && <div className="text-sm text-slate-500 mt-1">{hint}</div>}
    </div>
  );
}
